import { COMMON_PAGE_PATHS } from '../../constans/url-constants';
import { extractPathIdentifier } from '../../utils/helpers/api-helpers';
import PermissionsStore from './permissions-store';

let permissionsStore: PermissionsStore | null = null;

const getPermissionsStore = (): PermissionsStore => {
  if(permissionsStore == null) {
    permissionsStore = new PermissionsStore(extractPathIdentifier(COMMON_PAGE_PATHS.PRESENTATION));
  }

  return permissionsStore;
};

export { getPermissionsStore };
